
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricalClockOff as ObiElectricalClockOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electrical-clock-off.js';
 
 
 

 
 export const ObiElectricalClockOff = createComponent({
   react: React,
   tagName: 'obi-electrical-clock-off',
   elementClass: ObiElectricalClockOffElement,
   events: {
     
   }
  });
 
 